import spacing from 'material-ui/styles/spacing';

const colors = {
  brandPrimary1: '#00A7B8', // bondi blue
  brandPrimary2: '#74D4E0', // aquamarine blue
  brandSecondary1: '#333333', // mine shaft
  brandSecondary2: '#666666', // dove gray
  brandSecondary3: '#ABA8A7', // martini
  brandSecondary4: '#D5D6D5', // tasman
  brandSecondary5: '#E6E6E6', // mercury
  brandSecondary6: '#F7F4F1', // pearl brush
  brandSecondary7: '#B5E4E8', // powder blue
  brandSecondary8: '#FFFFFF', // white
  black: '#000000',

  harperYellow: '#FFDD00',
  ameliaOrange: '#FBB040',
  philoGreen: '#39B54A',
  pacoBlue: '#1B75BC',
  lamarRed: '#ED1C24',
  rubyViolet: '#92278F',
};

export default {
  spacing,
  fontFamily: 'Open Sans, sans-serif',
  palette: {
    primary1Color: colors.brandPrimary1,
    primary2Color: colors.brandPrimary2,
    secondary2Color: colors.brandSecondary2,
    secondary4Color: colors.brandSecondary4,
    secondary8Color: colors.brandSecondary8,
    secondary5Color: colors.brandSecondary5,
    borderColor: colors.black,
  },
  toolbar: {
    iconColor: colors.brandSecondary8,
    backgroundColor: colors.brandPrimary1,
    height: 60,
  },
  drawer: {
    color: colors.brandSecondary6,
    width: 263,
  },
  button: {
    textTransform: 'none',
  },
  flatButton: {
    textColor: colors.brandSecondary2,
  },
  raisedButton: {
    textColor: colors.brandSecondary2,
    secondaryColor: colors.brandPrimary2,
  },
  chip: {
    marginRight: 10,
    marginBottom: 10,
    backgroundColor: colors.brandPrimary1,
  },
  chipLabel: {
    fontSize: 12,
    color: colors.brandSecondary8,
  },
  divider: {
    marginLeft: 10,
    marginRight: 10,
  },
  selectedListItem: {
    backgroundColor: colors.brandSecondary7,
  },
  lessonCardDepths: {
    inactive: 1,
    active: 3,
  },
  characterColors: {
    harper: colors.harperYellow,
    amelia: colors.ameliaOrange,
    philo: colors.philoGreen,
    paco: colors.pacoBlue,
    lamar: colors.lamarRed,
    ruby: colors.rubyViolet,
  },
  addPostButton: {
    backgroundColor: colors.brandSecondary8,
    color: colors.brandPrimary1,
    borderRadius: 15,
  },
};



// WEBPACK FOOTER //
// ./app/styles/teamologyTheme.js